import type { ContractModalSource } from '#src/app/pages/ambassadors/landing/pageContext';
import { useTrackView } from '#src/app/shared/hooks/tracking';

export function useContractThanks(source: ContractModalSource | null): void {
	useTrackView('ambassadors_contract_thanks_view', { source_location: source ?? undefined });
}
